<template>
  <div class="main_form_box">
    <div class="main_form_bar">
      <div class="group_list_bar" v-show="!selectProjectGroupLoading">
        <span class="lable">请选择选项分组：</span>
        <div
          v-for="item in projectGroupList"
          :key="item.Id"
          :class="{
            group_item_active: item.selected,
            group_item: !item.selected
          }"
          @click="groupClick(item.Id)"
        >
          <i
            style="margin-right: 0px"
            class="iconfont"
            :class="{
              'icon-duoxuan-yixuanze': item.selected,
              'icon-32duoxuanweixuanzhong': !item.selected
            }"
          ></i>
          {{ item.Name }}
        </div>
        <el-link
          type="primary"
          :underline="false"
          icon="el-icon-circle-plus-outline"
          @click="editProjectGroup(null)"
        >
          新增组
        </el-link>
      </div>
      <div class="group_list_bar" v-show="selectProjectGroupLoading">
        <span class="lable">
          <i class="el-icon-loading"></i>
          加载中…
        </span>
      </div>
    </div>
    <div class="main_form_body">
      <div class="form_bar">
        <div class="form_bar_search">
          <el-button
            type="primary"
            icon="el-icon-download"
            size="mini"
            @click="exportTemplate()"
            :disabled="voteInfo.Status !== 0"
          >
            导出模板
          </el-button>
          <el-button
            type="primary"
            icon="el-icon-upload2"
            size="mini"
            @click="importData()"
            :disabled="voteInfo.Status !== 0"
          >
            批量导入
          </el-button>
          <el-button
            type="primary"
            icon="el-icon-plus"
            size="mini"
            @click="editProject(null)"
            :disabled="voteInfo.Status !== 0"
          >
            新增选项
          </el-button>
          <span class="select_message margin_left_10 margin_right_10">
            已选（{{ selectRows.length }}）个选项
          </span>
        </div>
        <div class="form_bar_btn">
          <el-button
            type="primary"
            @click="editVoteProject(false)"
            size="small"
            :disabled="voteInfo.Status !== 0"
          >
            保存
          </el-button>
          <el-button
            type="primary"
            @click="editVoteProject(true)"
            size="small"
            :disabled="voteInfo.Status !== 0"
          >
            下一步
          </el-button>
        </div>
      </div>
      <div class="form_content" style="min-height: 500px">
        <el-table
          ref="multipleTable"
          v-loading="tableLoading"
          :data="projectList"
          style="width: 100%"
          @selection-change="handleSelectionChange"
          @cell-mouse-leave="leaveCall"
          @row-click="selectRowChange"
          stripe
        >
          <el-table-column
            type="selection"
            width="55"
            :selectable="checkSelectable"
          >
          </el-table-column>
          <el-table-column
            type="index"
            label="序号"
            width="60"
          ></el-table-column>
          <el-table-column property="ProjectName" label="标题">
          </el-table-column>
          <el-table-column
            property="ProjectGroupName"
            label="分组名称"
            align="center"
          >
          </el-table-column>
          <el-table-column property="Remark" label="补充信息" align="center">
          </el-table-column>
          <el-table-column label="详细信息" align="center">
            <template slot-scope="scope">
              <el-popover placement="right" width="450" trigger="click">
                <div
                  v-html="scope.row.Remark1"
                  style="overflow: auto; max-height: 450px"
                ></div>
                <div
                  v-html="scope.row.Remark1"
                  style="max-height: 60px; overflow: hidden"
                  slot="reference"
                ></div>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column property="Sort" label="排序" align="center">
          </el-table-column>
        </el-table>
        <CommonImportExcel
          :fatherSubmitDialog="importExcelDialog"
          ref="importProject"
        ></CommonImportExcel>
        <EditProjectGroup
          :meetId="meetingId"
          :fatherSubmitDialog="editProjectGroupDialog"
          ref="editProjectGroup"
        ></EditProjectGroup>
        <CommonEditProject
          :ProjectGroupID="projectSelectQuery.ProjectGroupIds[0]"
          :MeetingID="meetingId"
          :fatherSubmitDialog="editProjectDialog"
          ref="editProject"
        ></CommonEditProject>
      </div>
    </div>
  </div>
</template>

<script>
import voteProjectApi from '../../../../api/vote/voteProject'
import voteManageApi from '../../../../api/vote/voteManage'
import CommonImportExcel from '@/components/project/CommonImportExcel.vue'
import EditProjectGroup from '@/components/project/EditProjectGroup.vue'
import CommonEditProject from '@/components/project/CommonEditProject.vue'
export default {
  name: 'EditVoteProject',
  components: {
    CommonImportExcel,
    EditProjectGroup,
    CommonEditProject
  },
  data () {
    return {
      meetingId: null,
      selectProjectGroupLoading: true,
      projectGroupList: [],
      groupListQuery: {
        meetingId: null,
        maxResultCount: 1000000,
        skipCount: 0
      },
      projectSelectQuery: {
        MeetingId: null,
        ProjectGroupIds: [],
        PrizeVoteIds: [],
        AwardStatus: 0
      },
      projectList: [],
      tableLoading: false,
      selectRows: [],
      voteProjectInfo: {}
    }
  },
  props: ['voteInfo'],
  inject: ['voteCheck', 'routeChange'],
  methods: {
    goBack: function () {
      this.$router.push({ name: 'meetingVote', params: { mid: this.$route.params.mid } })
    },
    changePriae: function () {
      this.searchProjects()
    },
    changeIsNoPrizeCheck: function () {
      this.searchProjects()
    },
    groupClick: function (groupId) {
      const _this = this
      _this.tableLoading = true
      let isAdd = true
      _this.projectSelectQuery.ProjectGroupIds.forEach(function (item, index) {
        if (item === groupId) {
          _this.projectSelectQuery.ProjectGroupIds.splice(index, 1)
          isAdd = false
        }
      })
      if (isAdd) {
        _this.projectSelectQuery.ProjectGroupIds.push(groupId)
      }
      _this.projectGroupList.forEach(function (item, index) {
        _this.$set(item, 'selected', false)
        _this.projectSelectQuery.ProjectGroupIds.forEach(function (selectItem, index) {
          if (item.Id === selectItem) {
            _this.$set(item, 'selected', true)
          }
        })
      })
      _this.searchProjects()
    },
    getDefaultProjectGroup: function () {
      const _this = this
      voteProjectApi.getDefaultProjectGroup({
        meetingId: _this.meetingId
      }).then(data => {
        if (!data) {
          _this.projectGroupList.unshift({ Id: null, Name: '默认组', Sort: 0 })
          _this.projectSelectQuery.ProjectGroupIds.push(null)
        } else {
          _this.projectSelectQuery.ProjectGroupIds.push(data.Id)
        }
        _this.projectSelectQuery.ProjectGroupIds.forEach(function (selectItem, index) {
          if (!selectItem) {
            _this.projectSelectQuery.ProjectGroupIds[index] = _this.projectGroupList[0].Id
          }
        })
        _this.projectGroupList.forEach(function (item, index) {
          _this.$set(item, 'selected', false)
          _this.projectSelectQuery.ProjectGroupIds.forEach(function (selectItem, index) {
            if (item.Id === selectItem) {
              _this.$set(item, 'selected', true)
            }
          })
        })
        this.getVoteProjectInfo()
        _this.selectProjectGroupLoading = false
      }).catch(err => {
        _this.selectProjectGroupLoading = false
        return err
      })
    },
    getProjectGroups: function () {
      const _this = this
      _this.selectProjectGroupLoading = true
      voteProjectApi.getProjectGroups(_this.groupListQuery).then(data => {
        _this.projectGroupList = data.Items
        _this.getDefaultProjectGroup()
      }).catch(err => {
        _this.selectProjectGroupLoading = false
        return err
      })
    },
    searchProjects: function () {
      const _this = this
      _this.tableLoading = true
      voteProjectApi.getProjectSelectList(_this.projectSelectQuery).then(data => {
        this.projectList = data
        this.$nextTick(() => {
          _this.projectList.forEach(function (row, index) {
            _this.voteProjectInfo.ProjectIds.forEach(function (selectItem, index) {
              if (row.ProjectId.toLowerCase() === selectItem.toLowerCase()) {
                _this.$refs.multipleTable.toggleRowSelection(row, true)
              }
            })
          })
        })
        this.tableLoading = false
      }).catch(err => {
        this.tableLoading = false
        return err
      })
    },
    handleSelectionChange: function (val) {
      this.selectRows = val
    },
    leaveCall: function (row, column, cell, event) {
      if (event.which === 1) {
        this.$refs.multipleTable.toggleRowSelection(row)
      }
    },
    selectRowChange: function (row, column, event) {
      this.$refs.multipleTable.toggleRowSelection(row)
    },
    checkSelectable: function (row) {
      if (this.voteInfo.Status !== 0) {
        return false
      } else {
        return true
      }
    },
    getVoteProjectInfo: function () {
      const _this = this
      _this.tableLoading = true
      voteManageApi.getVoteProjectInfo({
        voteId: _this.$route.params.vid
      }).then(data => {
        _this.voteProjectInfo = data
        _this.searchProjects()
      }).catch(err => {
        this.tableLoading = false
        return err
      })
    },
    editVoteProject: function (isNext) {
      const _this = this
      const openLoading = _this.openLoading('保存中…')
      const selectIds = []
      this.selectRows.map(item => {
        selectIds.push(item.ProjectId)
      })
      this.voteProjectInfo = {
        Id: this.$route.params.vid,
        SelectNumber: this.selectRows.length,
        SelectProjectNum: this.selectRows.length,
        SmallSelectNumber: this.selectRows.length,
        ProjectIds: selectIds
      }
      voteManageApi.editVoteProject(this.voteProjectInfo).then(data => {
        // _this.$root.$emit('voteCheck')
        this.voteCheck()
        openLoading.close()
        _this.$message({
          showClose: true,
          type: 'success',
          message: '保存成功!'
        })
        if (isNext) {
          _this.$router.push({
            name: 'editPublicVoteSetting',
            params: { mid: _this.$route.params.mid, vid: _this.$route.params.vid }
          })
        }
      }).catch(err => {
        // _this.$root.$emit('voteCheck')
        this.voteCheck()
        openLoading.close()
        return err
      })
    },
    projectGroupManager: function () {
      this.$router.push({ name: 'voteProjectGroup', params: { mid: this.$route.params.mid, vid: this.$route.params.vid } })
    },
    importData: function () {
      if (this.projectSelectQuery.ProjectGroupIds.length > 1) {
        this.$message({
          showClose: true,
          type: 'warning',
          message: '导入待评项只能指定一个项目组！'
        })
      }
      if (this.projectSelectQuery.ProjectGroupIds.length === 0) {
        this.$message({
          showClose: true,
          type: 'warning',
          message: '请选择项目组再导入待评项！'
        })
      }
      if (this.projectSelectQuery.ProjectGroupIds.length === 1) {
        let projectGroupId = null
        projectGroupId = this.projectSelectQuery.ProjectGroupIds[0]
        this.$refs.importProject.openImportExcel(projectGroupId, this.$route.params.mid)
      }
    },
    importExcelDialog: function (projectGroupID) {
      this.getProjectGroups()
      // this.getVoteProjectInfo()
    },
    editProjectGroup: function (projectGroupID) {
      this.$refs.editProjectGroup.openEditProjectGroup(projectGroupID)
    },
    editProjectGroupDialog: function () {
      this.getProjectGroups()
    },
    exportTemplate: function () {
      const _this = this
      let projectGroupId = null
      if (_this.projectSelectQuery.ProjectGroupIds.length > 0) {
        projectGroupId = _this.projectSelectQuery.ProjectGroupIds[0]
      }
      const openLoading = _this.openLoading()
      voteProjectApi.exportCommonProjectTemplate({
        MeetingId: _this.$route.params.mid,
        ProjectGroupId: projectGroupId
      }).then(data => {
        if (!data) {
          return
        }
        let fileName = '投票选项'
        if (projectGroupId) {
          _this.projectGroupList.forEach(function (item, index) {
            if (item.Id === projectGroupId) {
              fileName = item.Name
            }
          })
        }
        const fileUrl = window.URL.createObjectURL(new Blob([data], { type: 'application/vnd.ms-excel;charset=utf-8' }))

        const elink = document.createElement('a')
        // 设置下载文件名
        elink.setAttribute('download', fileName + '.xls')
        elink.style.display = 'none'
        elink.href = fileUrl
        document.body.appendChild(elink)
        elink.click()

        document.body.removeChild(elink) // 下载完成移除元素
        window.URL.revokeObjectURL(fileUrl) // 释放掉blob对象
        openLoading.close()
      }).catch(err => {
        openLoading.close()
        return err
      })
    },
    editProject: function (projectId) {
      if (this.projectSelectQuery.ProjectGroupIds.length > 1) {
        this.$message({
          showClose: true,
          type: 'warning',
          message: '新增选项项只能指定一个分组！'
        })
      }
      if (this.projectSelectQuery.ProjectGroupIds.length === 0) {
        this.$message({
          showClose: true,
          type: 'warning',
          message: '请选择分组再新增选项！'
        })
      }
      if (this.projectSelectQuery.ProjectGroupIds.length === 1) {
        this.$refs.editProject.openEditProject(projectId)
      }
    },
    editProjectDialog: function () {
      this.getProjectGroups()
      // this.getVoteProjectInfo()
    }
  },
  created () {
    this.meetingId = this.$route.params.mid
    this.groupListQuery.meetingId = this.$route.params.mid
    this.projectSelectQuery.MeetingId = this.$route.params.mid
    this.getProjectGroups()
    this.routeChange()
    this.voteCheck()
  }
}
</script>
<style lang="less">
.search_bar .el-select__tags-text {
  display: inline-block;
  max-width: 50px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.search_bar .el-select .el-tag__close.el-icon-close {
  top: -7px;
}
</style>
